import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './LicensePlate.css';

export default function LicensePlate({ plateNumber }) {
    const arabicNum = "٠١٢٣٤٥٦٧٨٩";
    // ... object ...

    const splitLicense = (license) => {
        // ... implementation ...
        if (license) {
            const digits = license.match(/\d/g) || [];
            const letters = license.match(/[^\d\s]/g) || [];
            return [digits, letters];
        }
        return [[], []];
    };

    const plate = splitLicense(plateNumber);

    // Function to render numeric plates horizontally
    const renderNumericPlates = (plates) => {
        return (
            <div className='d-flex fw-bold'>
                {plates.map((ele, index) => (
                    <span key={`numeric-${index}`} className='fs-9 px-1 license-plate-number'>{ele}</span>
                ))}
            </div>
        );
    };

    // Function to render letter plates horizontally
    const renderLetterPlates = (plates) => {
        return (
            <div className='d-flex fw-bold fs-7 '>
                {plates.map((ele, index) => (
                    <span key={`letter-${index}`} className='fs-9 px-1 license-plate-letter'>{ele}</span>
                ))}
            </div>
        );
    };

    if (!plate || (!plate[0].length && !plate[1].length)) return <span>{plateNumber}</span>;

    return (
        <div className='d-flex flex-column col-12 rounded rounded-2 border license-plate-box' style={{ maxWidth: '150px', backgroundColor: '#f8f9fa' }}>
            <div className='d-flex justify-content-around align-items-center bg-danger col-12' style={{ borderTopLeftRadius: '0.25rem', borderTopRightRadius: '0.25rem' }}>
                <div className='col-6 text-center d-flex justify-content-center align-items-center '>
                    <p className='m-0 fw-bold fs-7 text-white license-plate-header-text'>EGYPT</p>
                </div>
                <div className='col-6 text-center d-flex justify-content-center align-items-center'>
                    <p className='m-0 fw-bold fs-6 pb-1 text-white license-plate-header-text'>مصر</p>
                </div>
            </div>
            <div className='d-flex justify-content-around col-12 py-1'>
                <div className='d-flex flex-column align-items-center px-2'>
                    {renderNumericPlates(plate[0])}
                </div>
                <div className='d-flex flex-column align-items-center plate-be px-2 border-start'>
                    {renderLetterPlates(plate[1])}
                </div>
            </div>
        </div>
    );
}

